module.exports = __webpack_public_path__ + "img/home-quotation-orange.5949dafb.png";